import React from 'react'
import { FaSpinner } from 'react-icons/fa'
import './spinner.scss'

const Spinner = () => {
  return (
    <div className="spinner">
      <FaSpinner />
    </div>
  )
}

export default Spinner
